export default __webpack_public_path__ + "static/media/Close.6ce2d22f.svg";